export const CAMPAIGN_LIST_TABLE_VIEW_MODE = [
  { text: 'All', value: 'all', label: 'All', name: 'archived' },
  { text: 'Active', value: 'active', label: 'Active', name: 'archived' },
  { text: 'Archived', value: 'deleted', label: 'Archived', name: 'archived' },
];

export const CAMPAIGN_LIST_VIEW_MODE_VALUE = { active: 'true', deleted: 'false' };

export const ACTION_BUTTON_TEXT_OPTIONS = { active: 'Archive', deleted: 'Unarchive' };
